(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-bea-catalog]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var grid = root.querySelector('[data-catalog-grid]');
      if (!grid) return;
      var cards = Array.from(grid.querySelectorAll('[data-catalog-card]'));
      var initialSort = grid.dataset.sort;
      cards.forEach(function (card, i) { card.dataset.original = i; });
      var form = root.querySelector('[data-catalog-sort]');
      var select = form && form.querySelector('select');
      var input = root.querySelector('[data-catalog-search]');
      var count = root.querySelector('[data-catalog-count]');
      var empty = root.querySelector('[data-catalog-empty]');
      var singlePage = Number(grid.dataset.pages) <= 1;
      function normalize(s) { return s.toLocaleLowerCase((document.documentElement.lang || 'de')).normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
      function filter() {
        var term = normalize(input ? input.value.trim() : '');
        var shown = 0;
        cards.forEach(function (card) { card.hidden = !normalize(card.dataset.title).includes(term); if (!card.hidden) shown++; });
        if (count) count.textContent = term ? shown + ' von ' + cards.length + ' Produkten' : cards.length + ' Produkte';
        if (empty) empty.hidden = shown !== 0 || cards.length === 0;
      }
      if (singlePage && input) {
        root.querySelector('[data-catalog-search-wrap]').hidden = false;
        input.addEventListener('input', filter);
        root.querySelector('[data-catalog-reset]').addEventListener('click', function () { input.value = ''; filter(); input.focus(); });
        filter();
      }
      if (form && select) {
        // Keep Shopify preview and existing collection tags when a server sort is required.
        var params = new URLSearchParams(window.location.search);
        ['preview_theme_id', '_fd', 'pb', 'filter.v.availability'].forEach(function (key) {
          if (!params.has(key)) return;
          var hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = key; hidden.value = params.get(key); form.appendChild(hidden);
        });
        form.addEventListener('submit', function (event) {
          var mode = select.value;
          if (!singlePage || ['manual', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending'].indexOf(mode) < 0 || (mode === 'manual' && initialSort !== 'manual')) return;
          event.preventDefault();
          var sorted = cards.slice().sort(function (a, b) {
            var delta = 0;
            if (mode.indexOf('price-') === 0) delta = Number(a.dataset.price) - Number(b.dataset.price);
            else if (mode.indexOf('title-') === 0) delta = a.dataset.title.localeCompare(b.dataset.title, (document.documentElement.lang || 'de'));
            else delta = Number(a.dataset.rank) - Number(b.dataset.rank);
            if (mode.endsWith('descending')) delta = -delta;
            return delta || Number(a.dataset.original) - Number(b.dataset.original);
          });
          sorted.forEach(function (card) { grid.appendChild(card); });
          var url = new URL(window.location.href); url.searchParams.set('sort_by', mode); window.history.replaceState(null, '', url);
        });
        select.addEventListener('change', function () { if (form.requestSubmit) form.requestSubmit(); });
      }
    });
    scope.querySelectorAll('[data-bea-lotion-video]').forEach(function (video) {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      // The owner's original film, played by the browser without an app dependency.
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
